var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.wuenscheMitBezGR.length > 0)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",value:({
    title: _vm.tooltipHtml,
    html: true,
    customClass: 'gr-wunsch-tooltip',
  }),expression:"{\n    title: tooltipHtml,\n    html: true,\n    customClass: 'gr-wunsch-tooltip',\n  }",modifiers:{"hover":true,"right":true}}],staticClass:"text-danger d-inline-flex",staticStyle:{"cursor":"pointer"}},[_c('UsersRound',{attrs:{"size":16}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }